module.exports = __webpack_public_path__ + "img/fig03.2d1a28d8.jpg";